import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const forWho = ['Empleados que sienten que su puesto está en riesgo.', 'Profesionales "quemados" (burnout) que quieren renunciar con un plan sólido.', 'Personas recién despedidas que necesitan saber qué pasos dar mañana mismo.', 'Freelancers y contratados que quieren entender sus derechos reales.'];
const notForWho = ['Personas que esperan que el gobierno o su empresa les resuelva la vida.', 'Gente que no está dispuesta a leer y aplicar tácticas de negociación.', 'Dueños de empresas que buscan cómo despedir gente (esto es para el empleado).'];
export function ForNotFor() {
  return <section className="bg-navy text-white py-16 px-6" data-id="element-71">
      <div className="max-w-6xl mx-auto" data-id="element-72">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-73">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-74">
            <h2 className="font-serif text-3xl md:text-4xl mb-8 text-gold" data-id="element-75">
              Para Quién Es Esto
            </h2>
            <div className="space-y-4" data-id="element-76">
              {forWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-77">
                  <CheckCircleIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-78" />
                  <p className="text-lg" data-id="element-79">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-80">
            <h2 className="font-serif text-3xl md:text-4xl mb-8 text-red-400" data-id="element-81">
              Para Quién NO Es Esto
            </h2>
            <div className="space-y-4" data-id="element-82">
              {notForWho.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-83">
                  <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-84" />
                  <p className="text-lg" data-id="element-85">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}